import { Setting } from '../types/constant/PagesPropsType';
import { useEffect, useState } from 'react';
import { CancelSurveyApiType } from '../types/api/CancelSurveyApiType';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

/**
 * 画面表示時に解約アンケート情報を取得する
 *
 * @param setting
 */
export const useCancelSurvey = (setting: Setting) => {
  const [cancelSurvey, setCancelSurvey] = useState<CancelSurveyApiType>();

  useEffect(() => {
    axios
      .post(
        `${CUSTOMER_API_URL}?action=getCancelSurvey`,
        {},
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        setCancelSurvey(response.data as CancelSurveyApiType);
      })
      .catch((e) => console.log(e));
  }, []);

  return {
    cancelSurvey,
  };
};
